import { useMutation } from "@apollo/client";
import { EditMeMutation, EditMeMutationVariables } from "gql/graphql";
import { useAuth } from "modules/providers/auth-provider";
import EDIT_ME_MUTATION from "./_networking/edit-me";
import { useCallback } from "react";

const useToggleUserHideEmail = () => {
  const { me } = useAuth();

  const [editMeMutationAPI] = useMutation<
    EditMeMutation,
    EditMeMutationVariables
  >(EDIT_ME_MUTATION);

  return useCallback(() => {
    if (!me) {
      return;
    }

    editMeMutationAPI({
      variables: {
        input: {
          isHideEmail: !me.isHideEmail,
        },
      },
      optimisticResponse: {
        editMe: {
          __typename: "User",
          ...me,
          id: me.id,
          isHideEmail: !me.isHideEmail,
        },
      },
    });
  }, [editMeMutationAPI, me]);
};

export default useToggleUserHideEmail;
